<template>
  <div class="b-fff w100p pl20 pt10">
    <a-breadcrumb>
      <a-breadcrumb-item><a href="/">Home</a></a-breadcrumb-item>
      <a-breadcrumb-item>System List</a-breadcrumb-item>
    </a-breadcrumb>
    <tree></tree>
  </div>
</template>
<script>
import { reactive, toRefs, ref } from 'vue'
import tree from './components/tree.vue'
export default {
  components: {
    tree
  },
  setup() {
    const num = ref(0)
    const state = reactive({})
    return {
      num,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped></style>
